import lang from './lang';

export const ALL_GENDERS_VALUE = 'All';
export const ALL_GENDERS_LIST = ['Female', 'Male'];

export default new Map([
  [ALL_GENDERS_VALUE, lang('all', 'All')],
  ['Female', lang('female', 'Female')],
  ['Male', lang('male', 'Male')],
]);



// WEBPACK FOOTER //
// ./src/config/genders.js